import { createClass as _createClass } from "\0rollupPluginModLoBabelHelpers.js";
import { inheritsLoose as _inheritsLoose } from "\0rollupPluginModLoBabelHelpers.js";
import { defineProperty as _defineProperty } from "\0rollupPluginModLoBabelHelpers.js";

var _class, _class2, _temp;

import { cclegacy as _cclegacy } from "cc";

_cclegacy._RF.push({}, "1f0e2CqHXtPvoW/l1Lo6F/Z", "DataAnalyze", undefined);

// Learn TypeScript:
//  - https://docs.cocos.com/creator/manual/en/scripting/typescript.html
// Learn Attribute:
//  - https://docs.cocos.com/creator/manual/en/scripting/reference/attributes.html
// Learn life-cycle callbacks:
//  - https://docs.cocos.com/creator/manual/en/scripting/life-cycle-callbacks.html
import { _decorator, Component, sys } from "cc";
import { App } from "../manager/App";
var ccclass = _decorator.ccclass,
    property = _decorator.property;
export var E_DataAnalyzeType;

(function (E_DataAnalyzeType) {
  E_DataAnalyzeType["GameBegin"] = "gameBegin";
  E_DataAnalyzeType["GameEnd"] = "gameEnd";
  E_DataAnalyzeType["TimeTimes"] = "timeTimes";
  E_DataAnalyzeType["SurvivalTimes"] = "survivalTimes";
  E_DataAnalyzeType["IndianaTimes"] = "indianaTimes";
  E_DataAnalyzeType["Ad_PreGain"] = "adPreGain";
  E_DataAnalyzeType["Ad_Weapon"] = "adWeapon";
  E_DataAnalyzeType["Ad_Skin"] = "adSkin";
  E_DataAnalyzeType["Ad_ResultTime"] = "adResultTime";
  E_DataAnalyzeType["Ad_ResultSurvival"] = "adResultSurvival";
  E_DataAnalyzeType["Ad_ResultIndiana"] = "adResultIndiana";
  E_DataAnalyzeType["Ad_Reborn"] = "adReborn";
  E_DataAnalyzeType["Ad_Begin"] = "adBegin";
  E_DataAnalyzeType["Ad_End"] = "adEnd";
  E_DataAnalyzeType["Dan"] = "dan";
  E_DataAnalyzeType["WeaponNum"] = "weaponNum";
  E_DataAnalyzeType["SkinNum"] = "skinNum";
  E_DataAnalyzeType["Interstitial_Begin"] = "InterstitialBegin";
})(E_DataAnalyzeType || (E_DataAnalyzeType = {}));

var DataAnalyze = ccclass(_class = (_temp = _class2 = /*#__PURE__*/function (_Component) {
  _inheritsLoose(DataAnalyze, _Component);

  function DataAnalyze() {
    return _Component.apply(this, arguments) || this;
  }

  var _proto = DataAnalyze.prototype;

  /**记录游戏次数 */
  _proto.recordTimes = function recordTimes(type) {
    if (sys.isNative) {
      App.GameCtrl.callJava("recordTimes", "(Ljava/lang/String;)V", [type]);
    }
  }
  /**武器数量 */
  ;

  _proto.weaponNum = function weaponNum(type, num) {
    if (sys.isNative) {
      App.GameCtrl.callJava("weaponNum", "(Ljava/lang/String;)V", [num.toString()]);
    }
  }
  /**皮肤数量 */
  ;

  _proto.skinNum = function skinNum(type, num) {
    if (sys.isNative) {
      App.GameCtrl.callJava("skinNum", "(Ljava/lang/String;)V", [num.toString()]);
    }
  }
  /**角色段位 */
  ;

  _proto.dan = function dan(_dan) {
    if (sys.isNative) {
      App.GameCtrl.callJava("dan", "(Ljava/lang/String;)V", [_dan]);
    }
  }
  /**广告 */
  ;

  _proto.ad = function ad(adType) {
    if (sys.isNative) {
      App.GameCtrl.callJava("ad", "(Ljava/lang/String;)V", [adType]);
    }
  } // update (dt) {}
  ;

  _createClass(DataAnalyze, null, [{
    key: "I",
    get: function get() {
      if (!DataAnalyze._I) {
        DataAnalyze._I = new DataAnalyze();
      }

      return DataAnalyze._I;
    }
  }]);

  return DataAnalyze;
}(Component), _defineProperty(_class2, "_I", null), _temp)) || _class;

export { DataAnalyze as default };

_cclegacy._RF.pop();